module.exports = __webpack_public_path__ + "media/2.5f52b054.wav";